module.exports = __webpack_public_path__ + "static/media/marker-black.4099aaaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Showcase/marker-black.svg
// module id = 598
// module chunks = 0